
import Vue from 'vue'

export default Vue.extend({
  name: 'RPHTabButton',
  props: {
    hash: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isMounted: false,
    }
  },

  computed: {
    hasCount(): boolean {
      return this.count !== null && this.count > 0
    },
  },
  mounted() {
    this.isMounted = true
  },

  methods: {
    scrollToSection(hash: any) {
      const element = document.querySelector(`#${hash}`)
      const hideElement = document.querySelector('.rph-header')
      if (element) {
        //@ts-ignore
        if (this.$router.history.current.hash !== `#${this.hash}`) {
          this.$router
            .replace({
              //@ts-ignore
              path: `${this.$router.history.current.fullPath}`,
              hash: this.hash,
            })
            .then(() => {
              this.$nextTick(() => {
                const rect = element.getBoundingClientRect()
                const hideHeight = hideElement ? hideElement.getBoundingClientRect().height : 0
                const overlapValue = hideHeight >= 200 ? 270 : 180
                const offset = rect.top + window.scrollY - overlapValue
                window.scrollTo({
                  top: offset,
                  behavior: 'smooth',
                })
              })
            })
        }
      }
    },
  },
})
